(() => {
  const widget = document.querySelector('.contact-widget');
  const panel = document.querySelector('#contact-panel');
  const launcher = document.querySelector('.contact-launcher');
  const closeButton = document.querySelector('.contact-close');
  const triggers = document.querySelectorAll('.contact-trigger');
  const status = document.querySelector('.contact-status');

  if (!widget || !panel || !launcher || !closeButton || !status) return;

  const openPanel = () => {
    panel.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    launcher.setAttribute('aria-label', 'Close contact options');
    status.textContent = 'Select your preferred contact method.';
    window.requestAnimationFrame(() => closeButton.focus());
  };

  const closePanel = (returnFocus = true) => {
    panel.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    launcher.setAttribute('aria-label', 'Open contact options');
    if (returnFocus) launcher.focus();
  };

  launcher.addEventListener('click', () => {
    if (panel.hidden) openPanel();
    else closePanel();
  });

  closeButton.addEventListener('click', () => closePanel());
  triggers.forEach((trigger) => trigger.addEventListener('click', openPanel));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) closePanel();
  });

  document.addEventListener('click', (event) => {
    if (!panel.hidden && !widget.contains(event.target) && !event.target.closest('.contact-trigger')) {
      closePanel(false);
    }
  });
})();
